import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const OFFER_START = new Date("2026-06-26T00:00:00+05:30");
const OFFER_END   = new Date("2026-06-28T23:59:59+05:30");

const ITEMS = [
  { emoji: "🎊", text: "Our Anniversary. Your Free Documents.",          short: "Free Documents This Anniversary!" },
  { emoji: "⭐", text: "Celebrating Trust with Free Property Documents.", short: "Trust · Free Documents." },
  { emoji: "🏡", text: "Know Before You Buy: Free Documents Now.",       short: "Know Before You Buy: Free!" },
  { emoji: "🎊", text: "Anniversary Special: Documents Free Today.",     short: "Anniversary · Docs Free!" },
  { emoji: "⭐", text: "Trusted Data. Better Decisions. Completely Free.", short: "Trusted. Free. Right Now." },
  { emoji: "🏡", text: "Every Smart Decision Starts with Free Records.",  short: "Smart Decisions Start Free." },
  { emoji: "🎊", text: "Our Anniversary Gift: Documents Free!",          short: "Our Gift to You: Free Documents!" },
  { emoji: "⭐", text: "Verify Before You Invest: Free Until 28 June.",  short: "Verify Free · Until 28 Jun." },
  { emoji: "⏳", text: "Limited-Time: Free Access to All Property Records.", short: "Limited-Time Free Access!" },
  { emoji: "🏡", text: "Free Until 28 June. No Credits. No Charges.",   short: "Free · No Credits Needed." },
];

const pad = (n) => String(n).padStart(2, "0");

const getTimeLeft = (target) => {
  const diff = target.getTime() - Date.now();
  if (diff <= 0) return null;
  const totalSec = Math.floor(diff / 1000);
  return {
    d: Math.floor(totalSec / 86400),
    h: Math.floor(totalSec / 3600) % 24,
    m: Math.floor(totalSec / 60) % 60,
    s: totalSec % 60,
  };
};

const getPhase = () => {
  const now = Date.now();
  if (now < OFFER_START.getTime()) return "before";
  if (now <= OFFER_END.getTime()) return new Date(now).getDate() === 28 ? "lastday" : "live";
  return "ended";
};

const AnnouncementBar = () => {
  const [index, setIndex]     = useState(0);
  const [visible, setVisible] = useState(true);
  const [, setTick]           = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const id = setInterval(() => {
      setVisible(false);
      setTimeout(() => { setIndex((i) => (i + 1) % ITEMS.length); setVisible(true); }, 300);
    }, 5000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  const phase = getPhase();
  if (phase === "ended") return null;

  const { emoji, text, short } = ITEMS[index];

  // ── Desktop timer (inline) ──
  let desktopTimer = null;
  // ── Mobile timer (stacked below) ──
  let mobileTimer = null;

  if (phase === "before") {
    const tl = getTimeLeft(OFFER_START);
    if (tl) {
      const segs = (
        <>
          {tl.d > 0 && <span className="jh-ann-timer-seg">{tl.d}<em>d</em></span>}
          <span className="jh-ann-timer-seg">{pad(tl.h)}<em>h</em></span>
          <span className="jh-ann-timer-seg">{pad(tl.m)}<em>m</em></span>
          <span className="jh-ann-timer-seg">{pad(tl.s)}<em>s</em></span>
        </>
      );
      desktopTimer = (
        <span className="jh-ann-timer jh-ann-timer--soon">
          <span className="jh-ann-timer-label">Offer starts in</span>
          {segs}
        </span>
      );
      mobileTimer = (
        <div className="jh-ann-mobile-timer jh-ann-mobile-timer--soon">
          <span className="jh-ann-mobile-status">⏳ Sale Starting Soon</span>
          <span className="jh-ann-timer jh-ann-timer--soon" style={{ marginLeft: 6 }}>{segs}</span>
        </div>
      );
    }
  } else if (phase === "live") {
    desktopTimer = (
      <span className="jh-ann-live">
        <span className="jh-ann-live-dot" aria-hidden="true" />
        Offer is Live
      </span>
    );
    mobileTimer = (
      <div className="jh-ann-mobile-timer jh-ann-mobile-timer--live">
        <span className="jh-ann-live-dot" aria-hidden="true" />
        Sale Live Right Now!
      </div>
    );
  } else if (phase === "lastday") {
    const tl = getTimeLeft(OFFER_END);
    if (tl) {
      const segs = (
        <>
          <span className="jh-ann-timer-seg">{pad(tl.h)}<em>h</em></span>
          <span className="jh-ann-timer-seg">{pad(tl.m)}<em>m</em></span>
          <span className="jh-ann-timer-seg">{pad(tl.s)}<em>s</em></span>
        </>
      );
      desktopTimer = (
        <span className="jh-ann-timer jh-ann-timer--end">
          <span className="jh-ann-timer-label">Offer ends in</span>
          {segs}
        </span>
      );
      mobileTimer = (
        <div className="jh-ann-mobile-timer jh-ann-mobile-timer--end">
          <span className="jh-ann-mobile-status">🔥 Ends in</span>
          <span className="jh-ann-timer jh-ann-timer--end" style={{ marginLeft: 6 }}>{segs}</span>
        </div>
      );
    }
  }

  return (
    <div
      className="jh-announce"
      role="button"
      tabIndex={0}
      onClick={() => { navigate("/states"); window.scrollTo(0, 0); }}
      onKeyDown={(e) => e.key === "Enter" && navigate("/states")}
      title="Get free property documents: Anniversary offer"
    >
      {/* ── DESKTOP layout: everything in one row ── */}
      <div className="jh-announce-inner jh-announce-desktop" style={{ opacity: visible ? 1 : 0 }}>
        <span className="jh-announce-emoji" aria-hidden="true">{emoji}</span>
        <span className="jh-announce-text">{text}</span>
        <span className="jh-announce-divider" aria-hidden="true" />
        {desktopTimer}
        <span className="jh-announce-badge">Free</span>
        <span className="jh-announce-cta">Get Yours →</span>
      </div>

      {/* ── MOBILE layout: tagline row + timer row ── */}
      <div className="jh-announce-mobile" style={{ opacity: visible ? 1 : 0 }}>
        {/* Row 1: emoji + short tagline + FREE badge */}
        <div className="jh-ann-mobile-row1">
          <span className="jh-announce-emoji" aria-hidden="true">{emoji}</span>
          <span className="jh-announce-text jh-announce-text--short">{short}</span>
          <span className="jh-announce-badge">Free</span>
        </div>
        {/* Row 2: sale status + timer */}
        {mobileTimer}
      </div>

      <style>{`
        /* ── Desktop: shown above 640px ── */
        .jh-announce-desktop { display: inline-flex; }
        .jh-announce-mobile  { display: none; }

        .jh-announce {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 11px 16px;
          background: transparent;
          cursor: pointer;
          user-select: none;
        }
        .jh-announce:hover .jh-announce-cta { opacity: 1; transform: translateX(0); }
        .jh-announce:hover .jh-announce-text { color: #0c2244; }

        .jh-announce-inner {
          align-items: center;
          gap: 12px;
          transition: opacity 0.3s ease;
        }
        .jh-announce-emoji {
          font-size: 18px; line-height: 1; flex-shrink: 0;
          display: inline-block;
          animation: jh-ann-zoom 2s ease-in-out infinite;
        }
        .jh-announce-text {
          font-size: 16.5px; font-weight: 700; color: #153568;
          letter-spacing: -0.01em; white-space: nowrap;
          transition: color 0.2s ease;
        }
        .jh-announce-divider {
          width: 1px; height: 16px;
          background: rgba(21,53,104,0.18); flex-shrink: 0;
        }
        .jh-ann-live {
          display: inline-flex; align-items: center; gap: 7px;
          font-size: 11.5px; font-weight: 800; letter-spacing: 0.06em;
          text-transform: uppercase; color: #059669;
          background: #ecfdf5; border: 1.5px solid #6ee7b7;
          border-radius: 999px; padding: 4px 12px;
          white-space: nowrap; flex-shrink: 0;
        }
        .jh-ann-live-dot {
          width: 7px; height: 7px; border-radius: 50%;
          background: #10b981; box-shadow: 0 0 0 2px rgba(16,185,129,0.25);
          flex-shrink: 0;
          animation: jh-dot-pulse 1.6s ease-in-out infinite;
        }
        .jh-ann-timer {
          display: inline-flex; align-items: center; gap: 5px;
          flex-shrink: 0; white-space: nowrap;
        }
        .jh-ann-timer-label {
          font-size: 11px; font-weight: 600; color: #6b7280;
          letter-spacing: 0.01em; margin-right: 2px;
        }
        .jh-ann-timer-seg {
          display: inline-flex; align-items: baseline; gap: 1px;
          font-size: 14px; font-weight: 800;
          letter-spacing: -0.02em; line-height: 1;
        }
        .jh-ann-timer-seg em {
          font-style: normal; font-size: 9.5px; font-weight: 600;
          color: #9ca3af; letter-spacing: 0; margin-left: 1px;
        }
        .jh-ann-timer--soon .jh-ann-timer-seg { color: #153568; }
        .jh-ann-timer--end  .jh-ann-timer-seg { color: #dc2626; }
        .jh-ann-timer--end  .jh-ann-timer-label { color: #dc2626; font-weight: 700; }

        .jh-announce-badge {
          font-size: 10px; font-weight: 800; letter-spacing: 0.09em;
          text-transform: uppercase; color: #fff;
          background: linear-gradient(135deg, #10b981, #059669);
          border-radius: 999px; padding: 4px 12px;
          white-space: nowrap; flex-shrink: 0;
          box-shadow: 0 2px 10px rgba(16,185,129,0.3);
          display: inline-block;
          animation: jh-ann-zoom 2s ease-in-out infinite;
          animation-delay: 1s;
        }
        .jh-announce-cta {
          font-size: 13px; font-weight: 700; color: #f5a300;
          letter-spacing: 0.02em; white-space: nowrap;
          opacity: 0; transform: translateX(-6px);
          transition: opacity 0.25s ease, transform 0.25s ease;
          flex-shrink: 0;
        }

        /* ── Mobile layout ── */
        @media (max-width: 640px) {
          .jh-announce-desktop { display: none; }
          .jh-announce-mobile  {
            display: flex; flex-direction: column;
            align-items: center; gap: 6px; width: 100%;
            transition: opacity 0.3s ease;
          }
          .jh-announce { padding: 10px 14px; }

          /* Row 1 */
          .jh-ann-mobile-row1 {
            display: flex; align-items: center;
            justify-content: center; gap: 8px; width: 100%;
          }
          .jh-announce-text--short {
            font-size: 13px; font-weight: 700; color: #153568;
            letter-spacing: -0.01em; white-space: nowrap;
            overflow: hidden; text-overflow: ellipsis;
          }

          /* Row 2: timer */
          .jh-ann-mobile-timer {
            display: inline-flex; align-items: center;
            gap: 6px; flex-shrink: 0;
          }
          .jh-ann-mobile-status {
            font-size: 10.5px; font-weight: 700; letter-spacing: 0.01em;
          }
          .jh-ann-mobile-timer--soon .jh-ann-mobile-status { color: #153568; }
          .jh-ann-mobile-timer--soon .jh-ann-timer-seg    { color: #153568; font-size: 13px; }

          .jh-ann-mobile-timer--live {
            font-size: 11px; font-weight: 800; letter-spacing: 0.05em;
            text-transform: uppercase; color: #059669;
            background: #ecfdf5; border: 1.5px solid #6ee7b7;
            border-radius: 999px; padding: 3px 12px;
          }

          .jh-ann-mobile-timer--end .jh-ann-mobile-status { color: #dc2626; font-weight: 800; }
          .jh-ann-mobile-timer--end .jh-ann-timer-seg     { color: #dc2626; font-size: 13px; }
        }

        @keyframes jh-ann-zoom {
          0%, 100% { transform: scale(1); }
          40%       { transform: scale(1.3); }
          55%       { transform: scale(1.22); }
          70%       { transform: scale(1.3); }
        }
        @keyframes jh-dot-pulse {
          0%, 100% { box-shadow: 0 0 0 2px rgba(16,185,129,0.25); }
          50%       { box-shadow: 0 0 0 5px rgba(16,185,129,0.08); }
        }
        @media (max-width: 768px) {
          .jh-ann-timer-label { display: none; }
          .jh-announce-cta    { display: none; }
          .jh-announce-text   { font-size: 14px; }
        }
        @media (prefers-reduced-motion: reduce) {
          .jh-ann-live-dot, .jh-announce-emoji, .jh-announce-badge { animation: none; }
        }
      `}</style>
    </div>
  );
};

export default AnnouncementBar;
